module.exports = __webpack_public_path__ + "img/wzlt2.2019dca2.png";